import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { IMealCreditFormFields } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';
import { getCheckoutDisplaySettingsRuleSubheader } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/CheckoutDisplaySettingsRule/hooks/getCheckoutDisplaySettingsRuleSubheader';

export interface UseGetCheckoutDisplaySettingsRuleSubheaderProps {
  isOrderPolicyVisible: boolean;
}

export interface UseGetCheckoutDisplaySettingsRuleSubheader {
  subheader: string;
}

export const useGetCheckoutDisplaySettingsRuleSubheader = ({
  isOrderPolicyVisible,
}: UseGetCheckoutDisplaySettingsRuleSubheaderProps): UseGetCheckoutDisplaySettingsRuleSubheader => {
  const { watch } = useFormContext<IMealCreditFormFields>();
  const displayBudgets = watch('displayBudgets');
  const orderPolicyAcceptanceRequired = watch('orderPolicyAcceptanceRequired');
  const subheader = getCheckoutDisplaySettingsRuleSubheader({
    displayBudgets,
    orderPolicyAcceptanceRequired,
    isOrderPolicyVisible,
  });

  return {
    subheader,
  };
};
